var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_969_3528",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0957031,
    y: 0.472656,
    width: 18,
    height: 18,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_969_3528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4954 1.60352H5.91685C4.75755 1.60352 3.81509 2.54597 3.81509 3.70385V3.8229H3.69746C2.53817 3.8229 1.5957 4.76536 1.5957 5.92324V15.243C1.5957 16.4009 2.53817 17.3433 3.69746 17.3433H12.276C13.4339 17.3433 14.3763 16.4009 14.3763 15.243V15.1239H14.4954C15.6547 15.1239 16.5957 14.1815 16.5957 13.0236V3.70385C16.5957 2.54597 15.6547 1.60352 14.4954 1.60352ZM13.3843 15.243C13.3843 15.8538 12.8868 16.3513 12.276 16.3513H3.69746C3.08522 16.3513 2.58777 15.8538 2.58777 15.243V5.92324C2.58777 5.31241 3.08522 4.81496 3.69746 4.81496H12.276C12.8868 4.81496 13.3843 5.31241 13.3843 5.92324V15.243ZM15.6036 13.0236C15.6036 13.6344 15.1062 14.1319 14.4954 14.1319H14.3763V5.92324C14.3763 4.76536 13.4339 3.8229 12.276 3.8229H4.80715V3.70385C4.80715 3.09303 5.3046 2.59558 5.91685 2.59558H14.4954C15.1062 2.59558 15.6036 3.09303 15.6036 3.70385V13.0236Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.5f58181aac9b23784ba12871805091c0.svg";
export { ForwardRef as ReactComponent };